import React from "react";
import dayjs from "dayjs";

import {
	CardContent,
	CardDate,
	CardHeaderContainer,
	CardMessage,
	CardProfilePicture,
	CardUserName,
	UpdateCardContainer
} from "./styles";

export function UpdateCard({ update }) {
	const profileColors = [
		"#534b99",
		"#e74c3c",
		"#3498db",
		"#2ecc71",
		"#f39c12",
		"#9b59b6",
		"#1abc9c",
		"#e67e22",
		"#34495e",
		"#e91e63"
	];

	function getUserColor(userId) {
		if (!userId) return profileColors[0];

		let hash = 0;
		for (let i = 0; i < userId.length; i++) {
			hash = userId.charCodeAt(i) + ((hash << 5) - hash);
		}

		const index = Math.abs(hash) % profileColors.length;
		return profileColors[index];
	}

	function getInitials(name) {
		if (!name) return "";

		const nameParts = name.trim().split(" ");
		const firstName = nameParts[0];
		const lastName = nameParts[1];

		if (nameParts.length === 1) {
			return (
				firstName.charAt(0).toUpperCase() + firstName.charAt(1).toUpperCase()
			);
		} else {
			return (
				firstName.charAt(0) + (lastName ? lastName.charAt(0) : "")
			).toUpperCase();
		}
	}

	function formatDate(dateString) {
		const date = dayjs(dateString);
		const today = dayjs();
		const yesterday = today.subtract(1, "day");

		if (date.isSame(today, "day")) {
			return `Hoje - ${date.format("HH:mm")}`;
		} else if (date.isSame(yesterday, "day")) {
			return `Ontem - ${date.format("HH:mm")}`;
		} else {
			return `${date.format("DD/MM")} - ${date.format("HH:mm")}`;
		}
	}

	return (
		<UpdateCardContainer>
			<CardProfilePicture
				style={{
					backgroundColor: getUserColor(update.createdBy._id)
				}}
			>
				<p>{getInitials(update.createdBy.name)}</p>
			</CardProfilePicture>
			<CardContent>
				<CardHeaderContainer>
					<CardUserName>{update.createdBy.name}</CardUserName>
					<CardDate>{formatDate(update.createdAt)}</CardDate>
				</CardHeaderContainer>

				<CardMessage>{update.message}</CardMessage>
			</CardContent>
		</UpdateCardContainer>
	);
}
